import type { AtsClient } from "@/types/ats/ats-sync-settings"

export type ClientRowWarning = "no-mapping" | "duplicate" | null

export interface ClientRowState {
  enabled: boolean
  warning: ClientRowWarning
}

export function getClientRowState(
  atsClients: AtsClient[],
  enabledLobIds: number[],
  duplicateAtsClientIds: Set<string>,
): ClientRowState {
  const enabled = enabledLobIds.length > 0
  const hasMapping = atsClients.length > 0
  const hasDuplicateMapping = atsClients.some((c) => duplicateAtsClientIds.has(c.id))

  const warning: ClientRowWarning = hasDuplicateMapping
    ? "duplicate"
    : !hasMapping && enabled
      ? "no-mapping"
      : null

  return { enabled, warning }
}
